import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.25 20h-1.5V9.5a.75.75 0 1 0 0-1.5h-4.5V5a.75.75 0 1 0 0-1.5H3.75a.75.75 0 0 0 0 1.5v15h-1.5a.75.75 0 1 0 0 1.5h21a.75.75 0 1 0 0-1.5m-3-10.5V20h-3V9.5zM5.25 5h10.5v15H13.5v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75V20H5.25zM12 20H9v-3.75h3zM6.75 8a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 0 1.5H7.5A.75.75 0 0 1 6.75 8m4.5 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 1 1 0 1.5H12a.75.75 0 0 1-.75-.75m-4.5 3.75A.75.75 0 0 1 7.5 11H9a.75.75 0 1 1 0 1.5H7.5a.75.75 0 0 1-.75-.75m4.5 0A.75.75 0 0 1 12 11h1.5a.75.75 0 1 1 0 1.5H12a.75.75 0 0 1-.75-.75"
    }, null, -1)
  ])))
}
export default { render: render }